module.exports = __webpack_public_path__ + "img/radiology.be061095.png";